import { render, staticRenderFns } from "./tabGajiPokok.vue?vue&type=template&id=76d22750"
import script from "./tabGajiPokok.vue?vue&type=script&lang=js"
export * from "./tabGajiPokok.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports